import type { PropsWithChildren, ReactNode } from 'react'
import { useState } from 'react'

import { Flex } from '../Flex'
import { Icon, type IconTypes } from '../Icon'
import { SlideToggle } from '../SlideToggle'
import { CollapsibleContentStyled } from './styles/CollapsibleContentStyled'
import { CollapsibleStyled } from './styles/CollapsibleStyled'

export interface ICollapsibleProps {
  title: ReactNode
  defaultOpen?: boolean
  open?: boolean
  onChange?: (open: boolean) => void
  expandIcon?: IconTypes
  collapseIcon?: IconTypes
  iconPosition?: 'left' | 'right'
  animated?: boolean
}

export const Collapsible = ({
  title,
  defaultOpen,
  open,
  onChange,
  expandIcon = 'chevron-thick-right',
  collapseIcon = 'chevron-thick-down',
  iconPosition = 'left',
  children,
  animated = false,
}: PropsWithChildren<ICollapsibleProps>) => {
  const [openState, setOpen] = useState(defaultOpen ? true : false)

  const isControlled = () => {
    return open !== undefined
  }
  const isOpen = isControlled() ? open : openState

  const toggleCollapsible = () => {
    if (isControlled()) {
      onChange(isOpen)
    } else setOpen(!isOpen)
  }

  return (
    <CollapsibleStyled iconPosition={iconPosition}>
      <div className='title' onClick={toggleCollapsible}>
        <Flex spacing={0}>
          <Flex.Row
            alignItems='center'
            flexWrap='nowrap'
            flexDirection={iconPosition === 'right' ? 'row-reverse' : 'row'}
            spacing={0}
          >
            <Flex.Item>
              <div className='icon-wrapper'>
                {isOpen ? (
                  <Icon icon={collapseIcon} />
                ) : (
                  <Icon icon={expandIcon} />
                )}
              </div>
            </Flex.Item>
            <Flex.Item flex='1 0'>{title}</Flex.Item>
          </Flex.Row>
        </Flex>
      </div>
      {!animated && isOpen && <div className='content'>{children}</div>}
      {animated && (
        <SlideToggle show={isOpen}>
          <div className='content'>{children}</div>
        </SlideToggle>
      )}
    </CollapsibleStyled>
  )
}

Collapsible.displayName = 'Collapsible'

Collapsible.Content = CollapsibleContentStyled
